import React, { useState, useEffect } from 'react'

import i18n from 'live/services/i18n';
import LiveSelect from 'live/components/forms/ui/select';
import { getExtensionsQualifier } from './api/google-integration';



const ConfigForm = ({ config = {sizePage: 0}, onChange }: any) => {    
    const [extensionsQualifiers, setExtensionsQualifiers] = useState();
    const [sizePage, setSizePage] = useState<number>(config.sizePage);
    const [selectedExtensionsQualifiers, setSelectedExtensionsQualifiers] = useState(config.extensionQualifier);

    useEffect(() => {
          getExtensionsQualifier().then(response => {        
          setExtensionsQualifiers(response.map(ele => ({ value: ele, label: ele })));
      });
    }, [])

    const handleChange = (key, value) => {
        onChange(key, value)
    }

    return (
       <>
          <div>
                <label>{i18n('Integração Google Maps')}</label>
                <LiveSelect
                    placeholder={i18n("Choose the integration")}
                    options={extensionsQualifiers}
                    value={selectedExtensionsQualifiers}
                    onChange={(value, obj) => {
                        handleChange('extensionQualifier', value)
                        setSelectedExtensionsQualifiers(obj);
                    }}
                />
          </div>        

          <div>
              <label>Size Page (max 30)</label>
              <input type="number" min={1} max={30} value={sizePage} onChange={({ target }) => {
                const val = +target.value
                if(val > 0 && val < 30){
                    handleChange('sizePage', val)
                    setSizePage(val)
                }
                else{
                  target.value = ''
                }
              }}/>

          </div>    
       </>
    );
}

export default ConfigForm;
